module.exports = __webpack_public_path__ + "static/media/blueCircleDeleteIcon.ba245ff4.svg";